import { Component } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-auth',
  imports: [NgOptimizedImage, RouterOutlet],
  templateUrl: './auth.layout.html',
  styleUrl: './auth.layout.css',
  host: { class: 'auth' },
})
export class AuthLayout {
  protected readonly year = new Date().getFullYear();
}
